<script setup>
import roles from '@/api/roles';
import { ref, inject } from 'vue';
import { useVModel } from '@vueuse/core';
import SelectCifra from '../inputs/SelectCifra.vue';

const props = defineProps({
  modelValue: { type: Array, default: () => ([]) },
});

const $I18n = inject('I18n');

const emits = defineEmits(['update:modelValue']);

const modelInterno = useVModel(props, 'modelValue', emits);

const options = ref([]);

roles.get().then((result) => {
  options.value = result.data;
});

</script>

<template>
  <SelectCifra
    v-model="modelInterno"
    :opciones="options"
    :multiple="true"
    campo-etiqueta="nombre"
    campo-id="id"
    :marcador="$I18n.t('Seleccione')"
  >
  </SelectCifra>
</template>
